module.exports = __webpack_public_path__ + "fonts/Splatch.10ceac19.ttf";